module.exports = __webpack_public_path__ + "static/media/20_000011.fed8cb25.jpg";